import * as styles from './styles.css';

export const cx = (names: string): string =>
  names
    .split(/\s+/)
    .map(name => styles[name])
    .filter(Boolean)
    .join(' ');
